import React from "react";
import { HeaderInfoContents, LogoContainer, SuccessMessage, TransactionResponse } from "./styles";

import logoImg from "../../../../../assets/images/logo.png";
import SeloSecurity from "../../../../../components/SeloSecurity/SeloSecurity";

const StatusPayment = (props) => {
  const environment = /(hml-)|(localhost)/.test(window.location.href);

  return (
    <>
      <HeaderInfoContents>
        <img
          src={props.styledPage.logo || logoImg}
          alt="MrPay"
        />
        <SeloSecurity bgColor={props.styledPage.background_color || "#F1B434"} />
      </HeaderInfoContents>

      <LogoContainer>
        <img src={props.transactionStatus.image} />
        <span>{props.transactionStatus.title}</span>
      </LogoContainer>

      <SuccessMessage>
        <p>{props.transactionStatus.message}</p>
      </SuccessMessage>

      {environment && (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "25px" }}>
          <TransactionResponse>
            <span>{props.responseMessage.message}</span>
            <span>{props.responseMessage.response}</span>
          </TransactionResponse>
        </div>
      )}
    </>
  );
};

export default StatusPayment;
